import { z } from 'zod';

import { TypeGlobalSection } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';

export const GlobalSectionEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    accessType: z.enum(['Authenticated Only', 'CSR Only', 'Public']),
    theme: z.string(),
    pageContent: z.array(z.any()).optional().nullable(),
    translations: z.record(z.string(), z.any()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateGlobalSectionEntry(data: TypeGlobalSection) {
  return GlobalSectionEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateGlobalSectionEntries(data: TypeGlobalSection[]) {
  return z.array(GlobalSectionEntrySchema).safeParse(data);
}
